import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  secretKey = 'b14ca5898a4e4133bhemnhgwnsksnej';

  private readonly SALT = CryptoJS.enc.Base64.parse('SXZhbiBNZWR2ZWRldg==');
  private readonly ITERATIONS : number;

  constructor() {
    this.ITERATIONS = environment.encryptionConfig.ITERATIONS;
  }
  // encrypt(value: string): string {
  //   return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  // }


  Encrypt(origin: string, secretKey: string): string {
    try {
      this.secretKey = secretKey;
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.secretKey);
      const originWordArray = CryptoJS.enc.Utf16LE.parse(origin);
      const keyAndIv = CryptoJS.PBKDF2(keyWordArray, this.SALT, {
        keySize: 256 / 32 + 128 / 32,
        iterations: this.ITERATIONS,
        hasher: CryptoJS.algo.SHA1
      });
      const hexKeyAndIv = CryptoJS.enc.Hex.stringify(keyAndIv);
      const hexKey = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(0, 64));
      const iv = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(64, hexKeyAndIv.length));
      return CryptoJS.AES.encrypt(originWordArray, hexKey, { iv: iv }).toString();
    }
    catch (error) {
      throw error;
    }
  }



  Decrypt(encrypted: string, secretKey: string): string {
    try {
      this.secretKey = secretKey;
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.secretKey);

      const keyAndIv = CryptoJS.PBKDF2(keyWordArray, this.SALT, {
        keySize: 256 / 32 + 128 / 32,
        iterations: this.ITERATIONS,
        hasher: CryptoJS.algo.SHA1
      });

      const hexKeyAndIv = CryptoJS.enc.Hex.stringify(keyAndIv);

      const hexKey = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(0, 64));
      const iv = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(64, hexKeyAndIv.length));

      const decryptedWordArray = CryptoJS.AES.decrypt(encrypted, hexKey, { iv: iv });
      return CryptoJS.enc.Utf16LE.stringify(decryptedWordArray);
    }
    catch (error) {
      throw error;
    }
  }

  // decrypt(textToDecrypt: string) {
  //   return CryptoJS.AES.decrypt(textToDecrypt, this.secretKey).toString(CryptoJS.enc.Utf8);
  // }
}
